function Heading({children}) {
  return (
    <>
      <h1 className="font-modak text-xl text-center mt-16 lg:mt-20 mb-6 mx-6 sm:mx-0">{children}</h1>
    </>
  );
}

export default Heading;
